module.exports = __webpack_public_path__ + "media/images/slide3-3cb0432c6578f5053fe56aa4edf8b948.webp";